import React from 'react';
import Toast, { ToastConfig } from 'react-native-toast-message';
import { default_toast_config } from './toastConfig';

export const ToastRoot = (props?: { config?: ToastConfig }) => (
  <Toast config={props?.config || default_toast_config} />
);
